import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@material-ui/core';
import cx from 'clsx';
export function QAPanel(_a) {
    var children = _a.children, className = _a.className;
    return (_jsx(Card, { className: cx('faq-panel', className), square: true, children: children }));
}
//# sourceMappingURL=QAPanel.js.map